import { useEffect } from "react";
import { useCheckoutContext } from "context/CheckoutContext";
import { Container, Button } from "react-bootstrap";

const ConfirmOrderSuccess = () => {
  const { checkout, setCheckout } = useCheckoutContext();
  const customerEmail = checkout.shipping?.email;
  const isLoggedIn = checkout.customerToken && checkout.customerToken !== "null";
  const isEnrollmentFlow = checkout.enrollType === "ambassador" || checkout.enrollType === "affiliate";

  useEffect(() => {
    setCheckout({ ...checkout, currentStep: 4 });
  }, []);

  const handleCreateAccount = () => {
    window.location.href = "https://oolalife.com/account/register";
  };

  const handleLoginToAccount = () => {
    window.location.href = "https://oolalife.com/account/login";
  };

  const renderContent = () => {
        if (isEnrollmentFlow) {
          return (
            <div className="mt-4">
              <p>
                Thank you for your purchase! Your order has earned you{' '}
                <strong>{checkout.orderPoints} Oola Moola</strong> to spend on future orders!
              </p>
              <p>
                Please review your order completion email for more details regarding your order.
              </p>

              <div className="mt-4 d-flex justify-content-center gap-3">
              <Button
                  variant="primary"
                  onClick={handleLoginToAccount}
                  style={{
                    backgroundColor: '#5BC0DE',
                    borderColor: '#5BC0DE',
                    padding: '10px 20px',
                    fontSize: '16px'
                  }}
                >
                  Login to Your Account
                </Button>
              </div>
            </div>
          );
        } else if (!isLoggedIn) {
           return (
             <div className="mt-4">
               <p>
                 Please create your free Oola account today to earn Oola Moola on future orders,
                 access your order history, manage subscription orders, and MORE!
               </p>

               <div className="mt-4 text-start">
                 <p><strong>To create your Oola account, follow these steps:</strong></p>
                 <ul style={{ listStyle: 'disc', paddingLeft: '20px' }}>
                   <li>
                     Visit the{' '}
                     <a
                       href="https://oolalife.com/account/register"
                       className="text-primary"
                       style={{ textDecoration: 'underline' }}
                     >
                       Account Creation page
                     </a>
                     .
                   </li>
                   <li>
                     Create your account with the email you provided at checkout: {' '}
                     <strong>{customerEmail}</strong>
                   </li>
                   <li>Navigate your account using the menu options.</li>
                 </ul>
               </div>

               <div className="mt-4">
                 <Button
                   variant="primary"
                   onClick={handleCreateAccount}
                   style={{
                     backgroundColor: '#5BC0DE',
                     borderColor: '#5BC0DE',
                     padding: '10px 20px',
                     fontSize: '16px'
                   }}
                 >
                   Create Your Account
                 </Button>
               </div>
             </div>
           );
        }
  };

  return (
    <div className="horizontalRuler">
      <Container className="p-0 w-75">
        <div className="mt-4 text-center">
          <h1 className="text-secondary-color">YOUR ORDER HAS BEEN PLACED!</h1>
          {checkout.orderId && (
            <p className="h6 mb-3">
              Order Number: <strong>#{checkout.orderId}</strong>
            </p>
          )}
          {renderContent()}
        </div>
      </Container>
    </div>
  );
};

export default ConfirmOrderSuccess;